// extracted by mini-css-extract-plugin
export default {"genMap":"WordMap_genMap__7YozS","map":"WordMap_map__AfBi7"};